import axios from 'axios';
import axiosInstance from '../config/axios';
import config from '../config/config';

// User Registration (No token required)
export const signupApi = async (formData) => {
  try {
    const response = await axios.post(`${config.baseURL}/register`, formData, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Signup failed";
  }
};

// User Login (No token required)
export const loginApi = async (formData) => {
  try {
    const response = await axios.post(`${config.baseURL}/login`, formData, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Login failed";
  }
};

// Forgot Password
export const forgotPasswordApi = async (formData) => {
  try {
    const response = await axios.post(`${config.baseURL}/forgot-password`, formData, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "failed";
  }
};

export const resetPasswordApi = async (formData) => {
  try {
    const response = await axios.post(`${config.baseURL}/reset-password`, formData, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "failed";
  }
};

// Logout (Token required)
export const logoutUser = async () => {
  try {
    const response = await axiosInstance.post('/logout');
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Logout failed";
  }
};